<script>
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

import supportedLocales from "@/util/i18n/supported-locales";

function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}
export default {
  name: "TopNavbar",
  props: {
    title: String
  },
  components: {},
  data() {
    return {
      showNav: false,
      submenusDown: [],
      scrTop: 0,
      scrX: 0
    };
  },
  computed: {
    curlang() {
      return this.$store.getters["guicms/CURLANG"];
    },
    user() {
      return this.$store.getters["guicms/USER"];
    },
    suppLangs() {
      let a = this.$store.getters["guicms/SITECFG"];
      let l = [];
      if (!a) return l;
      a.langCfg.list.forEach(lang => {
        let ll = lang.isoLangs.split(",");
        if (!ll || ll.length < 1) return;
        if (supportedLocalesInclude(ll[0])) l.push(lang);
      });
      return l;
    }
  },
  watch: {
    user(new1, old1) {
      if (new1 != null && old1 != null && new1.username == old1.username) {
        return;
      }
      console.log(`User changed from ${old1} to ${new1} !`);
      // this.checkConn();
    }
  },
  mounted() {
    // this.checkConn();
  },
  beforeDestroy() {
    console.log('before destroy');
    this.disconnect();
  },
  created() {
    window.document.body.setAttribute("class", "has-navbar-fixed-top");
    // document.body.addEventListener('scroll', this.handleScroll);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async logout() {
      console.log("logout...");
      this.showNav = false;
      try {
        let { data } = await this.$api1().post("/user/logout", {});
        this.$store.dispatch("guicms/USER_GET");
      } catch (e) {
        console.log("logout.err: " + e.message);
      }
    },
    togNav() {
      this.showNav = !this.showNav;
    },
    clickHome() {
      // this.togNav();
      this.$router.push({ path: "/" }).catch(e => {});
    },
    setLang(a) {
      console.log("setLang: " + a);
      this.$emit("langChange", a);
    },
    /**
     * handle window scroll event (incl. navbar auto-hide)
     */
    handleScroll() {
      try {
        var a = window.scrollY;
        var b = 10;
        this.scrTop = a;
        var wH = window.innerHeight;
        var bH = document.body.clientHeight;
        // console.log('scroll: winH vs bodyH = '+wH+'/'+bH);
        if (wH >= bH) {
          this.$refs.nav1.classList.remove("scrollUp");
          // console.log("force !scrUp");
          return;
        }
        if (this.scrX < this.scrTop && a > b + b) {
          this.$refs.nav1.classList.add("scrollUp");
        } else if (this.scrX > this.scrTop && !(a <= b)) {
          this.$refs.nav1.classList.remove("scrollUp");
        }
        this.scrX = this.scrTop;
      } catch (e) {
        console.log("handleScrUp.e: " + e);
      }
    },
    // send() {
    //   console.log("Send message:" + this.send_message);
    //   if (this.stompClient && this.stompClient.connected) {
    //     const msg = { name: this.send_message };
    //     console.log(JSON.stringify(msg));
    //     this.stompClient.send("/app/gmsg1", JSON.stringify(msg), {});
    //   }
    // },
    connect() {
      let user = this.$store.getters["guicms/USER"];
      if (user == null) {
        console.log("not connecting (user is null)");
        return;
      }
      console.log("gtalk.conn..");
      this.socket = new SockJS("/gtalk1");
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.debug = () => {};
      this.stompClient.heartbeat.outgoing = 30000;
      this.stompClient.heartbeat.incoming = 30000;
      this.stompClient.onDisconnect = () => {
        console.log("onDisconnect...");
        this.connected = false;
        setTimeout(() => {
          this.reqConn();
        }, 5000);
      };
      this.stompClient.onWebSocketClose = () => {
        console.log("gtalk.wsClose");
        this.connected = false;
        setTimeout(() => {
          this.reqConn();
        }, 5000);
      };
      this.stompClient.connect(
        user.username,
        "",
        frame => {
          console.log("gtalk.connected");
          this.connected = true;
          // console.log("frame: " + frame);
          this.stompClient.subscribe("/topic/guestTalkAdminNotif", tick => {
            // console.log(tick);
            // try {
            let aa = JSON.parse(tick.body);
            // console.log("got notif: "+aa.notifType);
            this.$store.dispatch("guicms/GTALK_PROCNOTIF", aa);
            // } catch (e) {
            //   console.log("parseFail: " + e.message);
            // }

            // this.$store.dispatch("igp/MSGS_ADD", JSON.parse(tick.body).content);
          });
          this.stompClient.subscribe("/topic/cwevt", tick => {
            console.log('cwevt.'+tick.body);
            let aa = JSON.parse(tick.body);
            this.$store.dispatch("guicms/CWEVT", aa);
          });
        },
        error => {
          console.log("stomp.ERR: " + error);
          this.connected = false;
        }
      );
    },
    disconnect() {
      console.log("diconnect req");
      if (this.stompClient) {
        console.log("diconnecting guesttalk");
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    checkConn() {
      let user = this.$store.getters["guicms/USER"];
      console.log('checkConn: user='+user+', isCon='+this.connected);
      if (user && !this.connected) {
        console.log("gTlk: need2conn");
        this.connect();
      } else {
        console.log("gTlk: need2disconn");
        // this.disconnect();
      }
    },
    reqConn() {
      let user = this.$store.getters["guicms/USER"];
      if (user && !this.connected) {
        console.log("gTlk: reqConn");
        this.connect();
      }
    },
    reqDisconn() {
      if (!this.connected) return;
      console.log("gTlk: need2disconn");
      this.disconnect();
    }
  }
};
</script>

<template>
  <!-- <div> -->
  <nav
    ref="nav1"
    class="navbar is-fixed-top"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <a @click="clickHome" class="navbar-item">
        <img src="/img/sitelogo1.svg" alt="Home" :title="$t('g.home')" />
      </a>
      <a
        role="button"
        class="navbar-burger burger"
        :class="{ 'is-active': showNav }"
        @click="togNav"
        aria-label="menu"
        aria-expanded="false"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div
      class="navbar-menu has-text-centered"
      :class="{ 'is-active': showNav }"
    >
      <div class="navbar-start" >
        <b-dropdown
          aria-role="list"
          mobile-modal
          v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'CMSMGR'])"
        >
          <a class="navbar-item" slot="trigger" slot-scope="{ active }">
            <span>{{ $t("igadm.cmgmt") }}</span>
            <b-icon :icon="active ? 'angle-up' : 'angle-down'"></b-icon>
          </a>

          <b-dropdown-item aria-role="menuitem" has-link
            ><router-link to="/guicms"
              >{{ $t("g.infotree") }} - {{ $t("igadm.gui") }}</router-link
            ></b-dropdown-item
          >
          <b-dropdown-item aria-role="menuitem" has-link
            ><router-link to="/guimediaplaylists">{{
              $tc("g.playlist", 2)
            }}</router-link></b-dropdown-item
          >
          <!-- <router-link to="/media" class="navbar-item">Media</router-link> -->
        </b-dropdown>

        <b-dropdown
          aria-role="list"
          mobile-modal
          v-if="$store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN'])"
        >
          <a class="navbar-item" slot="trigger" slot-scope="{ active }">
            <span>{{ $t("g.config") }}</span>
            <b-icon :icon="active ? 'angle-up' : 'angle-down'"></b-icon>
          </a>

          <b-dropdown-item aria-role="menuitem" has-link>
            <router-link to="/sitecfg">{{ $tc("g.maincfg", 2) }}</router-link>
          </b-dropdown-item>

          <b-dropdown-item aria-role="menuitem" has-link>
            <router-link to="/chpled"
              >{{ $tc("g.tvc", 2) }} &amp; {{ $tc("g.radio", 2) }}</router-link
            >
          </b-dropdown-item>
        </b-dropdown>

        <template
          v-if="
            $store.getters['guicms/HASROLE'](['RECEPTION', 'CMSMGR', 'USER'])
          "
        >
          <!-- <router-link to="/foliomgmt" class="navbar-item">{{
            $tc("g.reservation", 2)
          }}</router-link> -->
          <!-- <router-link to="/hskp" class="navbar-item">{{
            $tc("g.housekeeping", 2)
          }}</router-link> -->
        </template>

        <template
          v-if="$store.getters['guicms/HASROLE'](['EVENTS', 'EVTMGR', 'ADMIN'])"
        >
          <!-- <router-link to="/guicustomevts" class="navbar-item"
            >{{ $tc("g.event", 2) }} &amp;
            {{ $tc("g.schedule", 2) }}</router-link
          > -->
        </template>

        <template
          v-if="
            $store.getters['guicms/HASROLE'](['ADMIN', 'SITEADMIN', 'USER'])
          "
        >
          <router-link to="/sitewatch" class="navbar-item"
            >{{ $tc("g.device", 2) }} &amp;
            {{ $tc("g.infrastructure", 1) }}</router-link
          >
        </template>

        <!-- <router-link to="/foliomgmt" class="navbar-item">Folio management</router-link>
                <router-link to="/gmsgs" class="navbar-item">Messages</router-link> -->
        <!-- <router-link to="/cwatch" class="navbar-item">TV clients</router-link> -->

        <!-- <router-link to="/streamtool" class="navbar-item">Streams</router-link> -->
        <!-- <router-link to="/chplmon" class="navbar-item">ChannelMon</router-link> -->
        <!-- <router-link to="/advCfg" class="navbar-item">Others</router-link> -->
        <!-- <router-link to="/" class="navbar-item">Others</router-link> -->
        <!-- <router-link to="/survey_ed" class="navbar-item">Surveys</router-link> -->
        <!-- <router-link to="/playlists_evts" class="navbar-item"
          >Meetings &amp; custom welcome events</router-link
        > -->
      </div>

      <div class="navbar-end">
        <b-dropdown append-to-body aria-role="menu" @change="setLang">
          <a class="navbar-item" role="button" slot="trigger">
            <div v-if="curlang != null" class="media">
              <figure
                class="media-left"
                v-if="curlang.imgs && curlang.imgs.length >= 1"
              >
                <p class="image is-24x24">
                  <img :src="'/' + curlang.imgs[0]" :alt="curlang.nm" />
                </p>
              </figure>
              <div class="media-content" v-else>
                <span class="is-small">{{ curlang.nm }}</span>
              </div>
              <b-icon icon="angle-down" size="is-small"></b-icon>
            </div>
            <span v-else class="media">
              {{ $tc("g.lang", 1) }}
            </span>
          </a>

          <b-dropdown-item
            aria-role="menuitem"
            :value="l.isoLangs"
            v-for="l in suppLangs"
            :key="l.id"
          >
            <div class="media">
              <figure class="media-left" v-if="l.imgs && l.imgs.length >= 1">
                <p class="image is-32x32">
                  <img :src="'/' + l.imgs[0]" />
                </p>
              </figure>
              <div class="media-content">
                <h3>{{ l.nm }}</h3>
              </div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <template v-if="user != null">
          <div class="navbar-item is-size-7">
            <span class="">
              <!-- {{ $t("auth.username") }}: -->
              <strong>{{ user.username }}</strong></span
            >
          </div>
          <div class="navbar-item">
            <!-- <a class="button is-outlined" href="/logout">Log out</a> -->
            <b-button icon-left="sign-out-alt" @click="logout">{{
              $t("auth.logout")
            }}</b-button>
          </div>
        </template>
        <div v-else class="navbar-item">
          <!-- <a class="button is-outlined" href="/login">Log in</a> -->
          <b-button icon-left="sign-in-alt"></b-button>
        </div>
      </div>
    </div>
  </nav>
  <!-- </div> -->
</template>
